module.exports = __webpack_public_path__ + "img/greenlight-license-logo.7a29553f.png";